import { render } from "./ATagToRoute.vue?vue&type=template&id=e97e8450&ts=true"
import script from "./ATagToRoute.vue?vue&type=script&lang=ts"
export * from "./ATagToRoute.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__